<template>
  <div id="header" >
    <div class="head_box">
      <div class="head_L" @click="jump(0)">
        <img class="yhlogo" :src="require('@/static/yhlogo.png')" alt=""  />
        <img class="yhzh_txt" :src="require('@/static/yhzh_txt_new.png')" alt="" />
        <div class="shuom">
          <div>全球领先数字积分激励生态平台</div>
          <div>共享美好新生活</div>
        </div>
        
      </div>

      <div class="head_R">

        <div class="tab" :class="index === 0?'selectedStyle':''" @click="jump(0)">首页</div>

        <div class="tab tabs" :class="index === 1 || index === 2 || index === 6 ?'selectedStyle':''" >
         <div class="tab_h">
           产品
           <div class="right_arrow"></div>       
         </div>

         <div class="tab_list">
            <p @click="jump(1)" :class="index === 1?'selectedStyle2':''">卡优优预付</p>
            <!-- <p @click="jumpcrossBorder">蜂巢跨境</p> -->
            <p @click="jump(2)" :class="index === 2?'selectedStyle2':''">“蜜链盟”乡村振兴数字化平台</p>
            <!-- <p @click="jump(6)" :class="index === 6?'selectedStyle2':''">神椰</p> -->
         </div>
        </div>

        <div class="tab" :class="index === 3?'selectedStyle':''" @click="jump(3)">渠道合作及特色案例</div>
        <div class="tab" :class="index === 4?'selectedStyle':''" @click="jump(4)">资讯中心</div>
        <div class="tab" :class="index === 5?'selectedStyle':''" @click="jump(5)">关于我们</div>
        <div class="tab" :class="index === 7?'selectedStyle':''" @click="jump(7)" style="margin-right: 0">加入我们</div>
      </div>
    </div>
  </div>
</template>

<script>
// import evenClick from '../../utils/evenClick';
export default {
  props:{
      index:{
        type:Number,
        default:0
      }
    },
  data() {
    return {
      // indexStatus:true,
      // index:0,
    };
  },
  created () {
      // console.log(this.$route.path)
      // var path = this.$route.path
      // if(path == '/index'){ this.index = 0 }
      // else if(path == '/mlm'){ this.index = 1 }
      // else if(path == '/village'){ this.index = 2 }
      // else if(path == '/shenye'){ this.index = 6 }
      // else if(path == '/characteristic-cases'){ this.index = 3 }
      // else if(path == '/news/index' || path == '/news/details' || path == '/news/index-more' ){ this.index = 4 }
      // else if(path == '/about'){ this.index = 5 }
      // else if(path == '/recruit'){ this.index = 7 }
  },
  mounted() {
    // console.log(this.$route.path)
    // window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    //  var _this = this
    //  evenClick.$on('searchData', function (msg) { 
    //     //  _this.indexStatusFunc(msg)
    //      _this.indexStatus = msg
    //     //  console.log(msg)
    //  })
    //  evenClick.$on('changeState', function (index,status = false) { 
    //     //  _this.indexStatusFunc(msg)
    //       _this.index = index
    //       _this.indexStatus = status
    //     //  console.log(msg)
    //  })
    //  this.$forceUpdate()
  },
  methods: {
    jump(index){
    //  this.indexStatus = false
    //  this.index = index
     switch (index){
			case 0:
			   this.$router.push("/index");
				break;
			case 1:
				  this.$router.push("/mlm");
			    break;
			case 2:
			   this.$router.push("/village");
         break;
      case 3:
				  this.$router.push("/characteristic-cases");
			    break;
			case 4:
				this.$router.push("/news/index");
        break;
      case 5:
				this.$router.push("/about");
        break;
      case 6:
        this.$router.push("/shenye");
        break;
        case 7:
        this.$router.push("/recruit");
        break;
			default :
				// this.$router.push(this.$route.path);
		}
     
   },
     totop() {
      document.documentElement.scrollTop = 0 
      document.body.scrollTop = 0
    },
  },  
 
};
</script>

<style lang="scss" scoped>
@import "../../style/style";
.header-left {
  display: flex;
  align-items: center;
}
div {
  box-sizing: border-box;
}
#header{
  width: 100%;
  height: auto;
  background-color: #ffffff;
  // border-bottom: 0.5px solid #e6e6e6;
  box-shadow: 0px 4px 8px rgba(168, 168, 168, 0.25);
}
.head_box {
  margin: 0 auto;
  width: 1200px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
}
.head_L {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #767d8f;
  font-weight: 400;
  font-size: 15px;
  width: 480px;
  cursor: pointer;
  // .shuom{
  //   div:nth-child(1){
  //     font-weight: 100;
  //   }
  //   div:nth-child(2){
  //     font-weight: 100;
  //   }
  // }
}
.yhlogo {
  width: 32px;
  height: 33px;
  margin-right: 10px;
}
.yhzh_txt {
  width: 117px;
  height: 29px;
  margin-right: 18px;
}
.head_R {
  display: flex;
  align-items: center;
  flex-direction: row;
  
}

.tab {
  font-size: 18px;
  color: #333333;
  margin-right: 50px;
  cursor: pointer;
  // height: 36px;
  // line-height: 36px;
}
.tabs {
  // font-size: 18px;
  // color: #333333;
   position: relative;
   margin-right: 44px;
  // cursor: pointer;
  // height: 36px;
  // line-height: 36px;
}
.tabs .tab_h{
  display: flex;
  align-items: center;
  flex-direction: row;
}
.right_arrow{
  margin-left: 4px;
  border: 6.5px solid;
  border-color: #444444 transparent transparent transparent;
  border-radius: 1px;
  margin-top: 7px;
  border-radius: 4px;

}
.tab:hover {
  color: #3b80fe;
}
.tabs:hover {
  color: #3b80fe;
  .tab_h {
    .right_arrow{
     border-color: #3b80fe transparent transparent transparent;
    }
  }
  
}
.tabs:hover .tab_list {
  // opacity: 1;
  opacity: 1;
  visibility: visible;
  // top: 30px;
  // color: #333333;
}
.tab_list {
  position: absolute;
  width: 255px;
  background:url('https://kayouyou-1257308601.cos.ap-guangzhou.myqcloud.com/c0a49d62381449f0aae00370b0e9695c.png') no-repeat;
  background-size: 100% 100%;
  padding: 17px 15px 6px 15px;;
  font-size: 14px;
  top: 20px;
  left: -81px;
  z-index: 3;
  // background: #ffffff;
  // border-radius: 2px;
  opacity: 0;
  visibility: hidden;
  color: #222222;
  transition: 0.3s;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  // box-shadow: 0px 0px 5px 0px #C8C8C8;

}

.tab_list p {
  width: 100%;
  padding: 9px 0;
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  border-bottom: 1px solid #E6E6E6;
}
.tab_list p:last-child{
  border-bottom:unset;
}
.tab_list p:hover{
  color: #0D5FFF;
}

.head_R2 {
  display: flex;
  align-items: center;
}
#header .head_R .selectedStyle{
  font-weight: 700;
  font-size: 18px;
  color: #0D5FFF;
}
#header .head_R .selectedStyle2{
  color: #0D5FFF;
}
#header .head_R .selectedStyle .right_arrow{

  border-color: #0D5FFF transparent transparent transparent;
}


.homePageClass{
    background-color: unset !important;
    border-bottom:unset !important;
    box-shadow: none !important;
}
.homePageClass .head_L,.homePageClass .head_R .tab{
  color: #ffffff;
}
.homePageClass .head_R .tab_h .right_arrow{
    border-color: #ffffff transparent transparent transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue